import { render, staticRenderFns } from "./DReactBtn.vue?vue&type=template&id=497688a2&scoped=true&"
import script from "./DReactBtn.vue?vue&type=script&lang=js&"
export * from "./DReactBtn.vue?vue&type=script&lang=js&"
import style0 from "./DReactBtn.vue?vue&type=style&index=0&id=497688a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497688a2",
  null
  
)

export default component.exports